
                            const chunks = `/// #replace #define SIXTY_UNIFORMS_AREA
#define SIXTY_UNIFORMS_AREA
uniform float uTime, uSpeech;

varying vec2 vUv1;


/// #replace vec3 totalEmissiveRadiance = uEmissive;
vec3 totalEmissiveRadiance = vec3(0.);
totalEmissiveRadiance += vec3(0., 0., 0.3);

float intensity = 1. - vUv.x + uSpeech;
intensity += 0.1 * sin(uTime * 2.5);
intensity = smoothstep(0.9, 1., intensity);


#ifndef GLOW

	totalEmissiveRadiance *= 2. * intensity;
#else
	
	float glow = .3 * smoothstep(0.5, 0., length(vUv1 - vec2(0.5)));
	glow += 0.5 * smoothstep(0.2, 0., length(vUv1 - vec2(0.5)));
	diffuseColor.a = glow * intensity;
	// diffuseColor.a = 0.;
#endif
`;

                            function replace(chunksCode = '', defaultShader = '') {
                                const chunks = parseCode(chunksCode);
                                chunks.forEach(({ target, replace }) => {
                                    defaultShader = defaultShader.replace(target, replace);
                                });

                                return defaultShader;
                            }

                            function parseCode(code, pattern = '/// #replace') {
                                const replacements = [];
                                const lines = code.trim().split('\n');

                                for (let i = 0; i < lines.length; i++) {
                                    const line = lines[i].trim();
                                    if (line.startsWith(pattern)) {
                                        const target = line.replace(pattern, '');
                                        const replaceLines = [];
                                        let j = i + 1;

                                        while (j < lines.length && !lines[j].trim().startsWith(pattern)) {
                                            const nextLine = lines[j].trim();
                                            if (nextLine) {
                                                replaceLines.push(nextLine);
                                            }
                                            j++;
                                        }

                                        const replace = replaceLines.join('\n');
                                        replacements.push({ target: target.trim(), replace: replace.trim() });

                                        i = j - 1;
                                    }
                                }
                                return replacements;
                            }

                            export default {
                                use: (el) => {
                                    const instance = el.material || el;
                                    instance['fragmentShader'] = replace(chunks, instance['fragmentShader']);
                                    instance.needsUpdate = true;
                                    return el;
                                }
                            }
                        